import { Component, OnInit, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { TableFieldService, ZoningCodeService } from '../../core/services';
import { MatDialogConfig } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';

import * as _ from 'lodash';
import { TableType, AttributesStatisticCollectionNames } from 'src/shared/enums';
import { AttributeModel } from 'src/app/models';
import {
    IAttributesIdentifiers,
    IAttributesIdentifiersTableField
} from 'src/app/interfaces/attributes-identifiers.interface';
import { IZoningCodeModel } from 'src/app/interfaces/zoning-code-model.interface';
import IAttributesStatisticFlags = ZoneIQCalibration.IAttributesStatisticFlags;
import ITableField = ZoneIQCalibration.ITableField;
import { IAttributePopupEntityParams } from 'src/app/interfaces/attribute-popup-params.interface';

const EMPTY_ATTR_STAT = {};

@Component({
    standalone: false,
    selector: 'attributes',
    templateUrl: './attributes.component.html',
    styleUrls: ['./attributes.component.scss']

})
export class AttributesComponent implements OnInit, OnChanges {
    popupTitle = 'Add Comments/Link';
    popupComponent: any = null;
    entityName: AttributesStatisticCollectionNames = null;
    identifier = '';
    popoverOpen = false;

    readonly popoverPositions: ConnectedPosition[] = [
        {
            originX: 'center',
            originY: 'top',
            overlayX: 'center',
            overlayY: 'bottom',
            offsetY: -8
        }
    ];

    @HostBinding('class')
    readonly hostClass = 'attributes';

    @Input()
    identifiers: IAttributesIdentifiers;

    @Input() beforeSaveHook = null;

    @Input()
    showPopover: boolean;

    @Input()
    attributePopupTitleDetails?: string;

    @Input()
    calibrationEntity: any;

    private _tableField: IAttributesIdentifiersTableField | ITableField;

    private _parameters: IAttributePopupEntityParams;

    constructor(
        readonly tableFieldService: TableFieldService,
        readonly zoningCodeService: ZoningCodeService,
        readonly dialog: MatDialog
    ) {}

    ngOnInit() {
        this.setIdentifier();
        this.popupTitle = this.attributePopupTitleDetails ? `${this.popupTitle} - ${this.attributePopupTitleDetails}` : this.popupTitle;
    }

    ngOnChanges(changes: SimpleChanges): void {
        const ident = changes.identifiers;
        if (ident && ident.currentValue && ident.previousValue) {
            if (ident.currentValue.calibrationSetId !== ident.previousValue.calibrationSetId) {
                this.setIdentifier();
            }
        }
    }

    get selectedZoningCode(): IZoningCodeModel {
        return this.zoningCodeService.selectedZoningCode;
    }

    get areThereAttributes() {
        return (
            !!this.selectedZoningCode &&
            this.selectedZoningCode.attributes[this.entityName] &&
            this.selectedZoningCode.attributes[this.entityName].has(this.identifier)
        );
    }

    get attributesStatistic(): IAttributesStatisticFlags {
        return (
            (!!this.selectedZoningCode &&
                this.selectedZoningCode.attributes[this.entityName] &&
                this.selectedZoningCode.attributes[this.entityName].get(this.identifier)) ||
            EMPTY_ATTR_STAT
        );
    }

    areAttributesFlagsVisible(flags: IAttributesStatisticFlags): boolean {
        if (!flags) {
            return false;
        }

        return (
            flags.hasLinks ||
            flags.hasComments ||
            flags.hasAssumptions ||
            flags.IsNotCalibrated ||
            flags.isZoneCombination ||
            flags.IsDeleted ||
            flags.hasDescription ||
            flags.isCalibrationSet
        );
    }

    get parameters(): IAttributePopupEntityParams {
        if (!this._parameters) {
            this._parameters = this.getParameters();
        }
        return this._parameters;
    }

    get tableType() {
        return _.get(this.identifiers, 'tableType', null);
    }

    get calibrationSetId() {
        return _.get(this.identifiers, 'calibrationSetId', null);
    }

    get calibrationSetType() {
        return _.get(this.identifiers, 'calibrationSetType', null);
    }

    get typology() {
        return _.get(this.identifiers, 'typology', null);
    }

    get tableFieldOption() {
        return _.get(this.identifiers, 'tableFieldOption', null);
    }

    // TODO :: this is a mess. tableField should be strictly defined and not calculated inside final component
    get tableField() {
        if (!this._tableField) {
            if (this.tableType === TableType.CALIBRATION_USES || this.tableType === TableType.OVERLAY_TYPOLOGY) {
                return this.identifiers.tableField;
            }
            this._tableField = this.tableFieldService.tableFields.get(this.identifiers.tableField.name);
        }
        return this._tableField;
    }

    get tableFieldId() {
        return _.get(this.tableField, 'Id', null);
    }

    setIdentifier() {
        this.identifier = AttributeModel.getIdentifier(this.parameters);
    }

    async openAttributesPopup() {
        if (!this.popupComponent) {
            return;
        }

        const dialogConfig = new MatDialogConfig();
        dialogConfig.width = '50%';
        dialogConfig.panelClass = 'popup-container';
        dialogConfig.disableClose = true;
        dialogConfig.data = {
            title: this.popupTitle,
            parameters: this.parameters,
            calibrationEntity: this.calibrationEntity,
            beforeSaveHook: this.beforeSaveHook
        };

        const publishDialogRef = this.dialog.open(this.popupComponent, dialogConfig);
        publishDialogRef.afterClosed().subscribe();
    }

    setPopoverOpen(open: boolean): void {
        this.popoverOpen = open && this.areAttributesFlagsVisible(this.attributesStatistic);
    }

    protected getParameters(): IAttributePopupEntityParams {
        return {};
    }
}
